module.exports = __webpack_public_path__ + "static/media/td_logo.345d42d9.svg";